import {
  BaseFabricObject,
  fabricConfig,
} from '@/fabric';

fabricConfig.NUM_FRACTION_DIGITS = 5;

BaseFabricObject.ownDefaults.objectCaching = false;
BaseFabricObject.ownDefaults.originX = 'center';
BaseFabricObject.ownDefaults.originY = 'center';
